// Lightweight API client. Uses CRA proxy to forward /api to backend in dev.
const TOKEN_KEY = 'myactivities_token';

// In production, CRA sets PUBLIC_URL from package.json "homepage".
// We prepend it so API calls hit the same mount path as the app
// (e.g. "/dashboard/api/..." when homepage="/dashboard").
const BASE_URL = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const url = path.startsWith('http') ? path : `${BASE_URL}${path}`;
  const res = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const err = new Error((data && data.error) || `Request failed: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  // auth
  register: (data) => request('/api/auth/register', { method: 'POST', body: data, auth: false }),
  login: (data) => request('/api/auth/login', { method: 'POST', body: data, auth: false }),
  me: () => request('/api/auth/me'),
  // user profile
  updateProfile: (data) => request('/api/users/profile', { method: 'PUT', body: data }),
  // admin
  addUser: (data) => request('/api/admin/add-user', { method: 'POST', body: data }),
  updateUser: (id, data) => request(`/api/admin/users/${id}`, { method: 'PUT', body: data }),
  getAdminUsers: () => request('/api/admin/users'),
  sendTestEmail: (to) => request('/api/admin/send-test-email', { method: 'POST', body: { to } }),
  sendReminders: () => request('/api/admin/send-reminders', { method: 'POST' }),
  getUsers: () => request('/api/users'),
  getAdminProgressReport: (filter, startDate, endDate) => {
    let url = '/api/admin/progress-report';
    const params = [];
    if (filter) params.push(`filter=${filter}`);
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (params.length) url += '?' + params.join('&');
    return request(url);
  },
  // chores
  listChores: () => request('/api/chores'),
  createChore: (data) => request('/api/chores', { method: 'POST', body: data }),
  updateChore: (id, data) => request(`/api/chores/${id}`, { method: 'PUT', body: data }),
  toggleChore: (id) => request(`/api/chores/${id}/toggle`, { method: 'PATCH' }),
  toggleActive: (id) => request(`/api/chores/${id}/active`, { method: 'PATCH' }),
  deleteChore: (id) => request(`/api/chores/${id}`, { method: 'DELETE' }),
  // progress
  getProgress: () => request('/api/progress'),
  getLeaderboard: () => request('/api/leaderboard'),
};
